export default "#### Personal use\n\nYou’re buying for yourself\n";